import { render, staticRenderFns } from "./TKPendingRequestHistory.vue?vue&type=template&id=5a84e1eb&scoped=true"
import script from "./TKPendingRequestHistory.vue?vue&type=script&lang=js"
export * from "./TKPendingRequestHistory.vue?vue&type=script&lang=js"
import style0 from "./TKPendingRequestHistory.vue?vue&type=style&index=0&id=5a84e1eb&prod&lang=css&scoped=true"
import style1 from "./TKPendingRequestHistory.vue?vue&type=style&index=1&id=5a84e1eb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a84e1eb",
  null
  
)

export default component.exports